import React, { useState, useEffect, useRef, isValidElement } from 'react'
import { useParams } from 'react-router-dom';
import { useLocation } from 'react-router-dom';
import { Box, InputAdornment, Dialog, Modal, DialogContent, IconButton, Button, TextField, DialogTitle, Avatar, Checkbox } from '@mui/material';
import { styled } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { saveAs } from 'file-saver';
import { MdOutlinePhoneIphone } from "react-icons/md";
import EventIcon from '@mui/icons-material/Event';
// import { MdOutlineTextsms } from "react-icons/md";
// import { AiOutlineMail } from "react-icons/ai";
import SmsIcon from '@mui/icons-material/Sms';
import EmailIcon from '@mui/icons-material/Email';
import { ReactComponent as WhatsappFilled } from '../../Assets/img/icons/whatsapp-filled.svg';
// import { ReactComponent as Download } from "../../Assets/img/icons/Download-share.svg"
// import facebook from '../../Assets/img/icons/Facebook.svg'
// import whatsapp from '../../Assets/img/icons/whatsapp.svg'
// import insta from '../../Assets/img/icons/instagram.svg'
// import linkedin from '../../Assets/img/icons/linkedin.svg'
// import signal from '../../Assets/img/icons/signal.svg'
// import telegram from '../../Assets/img/icons/Telegram.svg'
// import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import DefaultProfileBg from "../../Assets/img/card/profilebg.png"
import DefaultProfile from "../../Assets/img/upload-image.png";
import DefaultLogo from "../../Assets/img/default-logo.png";
// import ShareIcon from "@mui/icons-material/Share";
import CloseIcon from "@mui/icons-material/Close";
// import QrCode2Icon from "@mui/icons-material/QrCode2";
// import QrCodeCard from "./Cards/QrCodeCard";
import QRCodeStyling from "qr-code-styling";
import axios from 'axios';
import MapIntegration from './Mapintegration';
import { getIconAndLabel } from '../Utilities/SocialMediaMapping'
import { socialLinksSections } from "../Utilities/SocialMediaMapping"
// import NeocardzWave from "../Utilities/NeocardzWave"
// import CardWaveStd from '../Utilities/CardWaveStd';
import AutoVcfcard from './AutoVcf';
import Vcfcard from './Vcfcard';
// import ConsentVcf from './ConsentVcf';
import { renderLayout } from './Cards/Layouts';
// import { ReactComponent as FileDownloadIcon } from "../../Assets/img/icons/Download-breadcrumb.svg";
// import { ReactComponent as ImQrcode } from "../../Assets/img/icons/QrCode_AllCards.svg";
import { ReactComponent as IoMdShare } from "../../Assets/img/icons/Share.svg";
import { ReactComponent as NonVerifiedTickNew } from "../../Assets/img/icons/Non-verified-icon.svg";
import { ReactComponent as VerifiedTickN } from "../../Assets/img/icons/Verified-icon-new.svg";
import loaderGif from '../../Assets/img/icons/Animation - 1718370478484.gif'
import PreviewFileItem from '../Utilities/PreviewFileItem';
import ReactPlayer from 'react-player';
import { MuiTelInput, matchIsValidTel } from 'mui-tel-input'
import { useQuantityContext } from '../QuantityContext';
import { motion } from 'framer-motion';
import UserDetails2Skeleton from '../LoadingSkeleton/UserDetails2Skeleton';
import MapWithAddress from './MapWithAddress';

const UserDetails2 = () => {
    // const { id } = useParams();
    const viewerToken = localStorage.getItem('objectId')?.trim();
    const apiKey = process.env.REACT_APP_API_KEY
    const { card, id } = useParams();
    const storedobjectId = id;
    const { openSnackbar, handleSuccess, handleFailure } = useQuantityContext();

    const headers = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${storedobjectId}`
    };

    const viewerheaders = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${viewerToken}`
    };

    const [photoBase64, setPhotoBase64] = useState('');
    const location = useLocation();
    const [userProfile, setUserProfile] = useState("");
    const [viewerProfile, setviewerProfile] = useState("");
    const [objectId, setobjectId] = useState("");
    const [isIdAvailable, setIsIdAvailable] = useState(false);
    const [loading, setLoading] = useState(true);
    const [isAccessible, setAccess] = useState(false);
    const [isNonuser, setNonuser] = useState(false);
    const [RequestPending, setRequestPending] = useState(false)
    const isViewCard = location?.pathname.includes('view-card');
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const [isModalOpen, setModalOpen] = useState(false);
    const [isviewcard, setViewCard] = useState(false);
    const [isvcf, setVcf] = useState(false);
    const [nonUserData, setNonUserData] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '+91',
        countryCode: '+91', // Default country code
        email: ''
    });
    const [selectedCountry, setSelectedCountry] = useState('IN'); // Default country
    // Validation state
    const [errors, setErrors] = useState({
        firstName: false,
        lastName: false,
        email: false,
        phoneNumber: false
    });




    const isSaveDisabled =
        !nonUserData.firstName.trim() ||
        !nonUserData.lastName.trim() ||
        !nonUserData.email.trim() ||
        !nonUserData.phoneNumber.trim() ||
        Object.values(errors).some(error => error);

    const handleInputChange = (event) => {
        const { name, value } = event.target;
        setNonUserData((prevFormData) => ({
            ...prevFormData,
            [name]: value,
        }));

        // Validate input
        if (value.trim() === "") {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: true
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false
            }));
        }
    };

    const ValidateErrorUpdate = (isValid, name) => {
        if (!isValid) {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: true
            }));
        } else {
            setErrors((prevErrors) => ({
                ...prevErrors,
                [name]: false
            }));
        }
    }

    // Handle country code change
    const handleCountryChange = (countryCode) => {
        setSelectedCountry(countryCode);
        // Validate the current phone number with the new country code
        const isValid = matchIsValidTel(nonUserData.phoneNumber, { defaultCountry: countryCode });

        ValidateErrorUpdate(isValid, "phoneNumber");
    };

    const handlePhoneChange = (value, name) => {
        setNonUserData(prevState => ({
            ...prevState,
            [name]: value
        }));

        const isValid = matchIsValidTel(value, { defaultCountry: selectedCountry });
        ValidateErrorUpdate(isValid, "phoneNumber");
    };

    const formatPhoneNumber = (phoneNumber) => {
        const match = phoneNumber.match(/^(\+\d{1,3})\s?(.*)$/);
        if (match) {
            const countryCode = match[1]; // country code part
            const mainNumber = match[2].replace(/\s+/g, ""); // removes internal spaces from main number
            return `${countryCode} ${mainNumber}`;
        }
        return phoneNumber; // returns the original if it doesn't match
    };

    const handleSubmit = async (event) => {
        event.preventDefault(); // Prevent form default submission

        const { firstName, phoneNumber, email } = nonUserData;
        if (!firstName || !phoneNumber || !email) {
            // Display an error message or alert to the user
            openSnackbar("Please fill in all required fields: First Name, Phone Number, and Email.", "info")
            return; // Prevent form submission
        }

        const combinedPhoneNumber = formatPhoneNumber(nonUserData.phoneNumber);

        // Prepare the data to send
        const payload = {
            ...nonUserData,
            phoneNumber: combinedPhoneNumber // Use combined phone number
        };

        console.log("non user data", payload);

        try {

            const response = await axios.post('/api/v1/usercontact/groups/add_nonuser', payload, { headers });

            console.log("repmsso", response);

            if (response.data.status === "SUCCESS") {
                handleSuccess("Connect request has been sent");
                setVcf(true);
            }
            else {
                console.log('Failed to connect:', response.data);
            }
        } catch (error) {
            handleFailure(error.response.data.message);
            console.error('Error while connecting:', error);
        }
    };

    const calculateAge = (dob) => {
        // If dob is null or undefined, return early
        if (!dob) {
            return null;
        }
        const birthDate = new Date(dob);
        const today = new Date();

        let age = today.getFullYear() - birthDate.getFullYear();
        const monthDifference = today.getMonth() - birthDate.getMonth();
        if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age > 0 ? age : null;
    };

    const handleViewMoreClick = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };
    const maxImages = 5; // Maximum images to display in two rows (4 per row)

    useEffect(() => {
        // Check if id is available
        if (id) {
            // console.log('id: ',id, 'card: ', card);
            setIsIdAvailable(true);
        }
    }, [id]);


    useEffect(() => {
        if (isvcf) {
            onSkip();  // Now call `onSkip` when `vcf` has been updated
        }
    }, [isvcf]);


    const [cardDetails, setCardDetails] = useState({
        User_ID: objectId,
        employee_id: '',
        company_id: '',
        profession_department: '',
        profession_id: '',
        company_website: '',
        is_professional_verified: false,
        professional_details_status: '',
        student_id: '',
        student_email_id: '',
        student_year: '',
        student_ending_year: '',
        student_currently_pursuing: false,
        education_level: '',
        institute: '',
        board: '',
        degree: '',
        field_of_study: '',
        grade: '',
        CardName: '',
        is_student_verified: false,
        student_details_status: '',
        CardType: 'Personal',
        prefix: '',
        suffix: '',
        title: '',
        nickname: '',
        summary: '',
        designation: '',
        company: '',
        profession_department: '',
        professional_email_id: '',
        profile_pic: '',
        logo: ''
    });



    const [CardStyles, setCardStyles] = useState({
        User_ID: objectId,
        CardType: 'Professional',
        font: '',
        size: '',
        style: '',
        colorPrimary: '',
        colorSecondary: '',
        colorTitle: '',
        colorLayout: '#0044c6',
        bgColor: '#ffffff',
        imageExtract: null,
        layoutStyle: '1'
    })
    const [CardQrStyles, setCardQrStyles] = useState({
        User_ID: objectId,
        CardType: 'Professional',
        // logoQr :null,
        eyeBall: '',
        eyeBallcolor: '',
        eyeFrame: '',
        eyeFrameColor: '',
        qrPattern: '',
        qrPatterncolor: '#121212',
        border: '',
        bordercolor: '',
        addbg: '',
        addbgcolor: '#ede8e8'
    })
    const [SocialLinks, setSocialLinks] = useState({
        user_ref_id: objectId,
        card_type: 'Professional',
        links: [
            { network: 'linkedin', url: 'https://www.linkedin.com/in/', visible: false },
            { network: 'facebook', url: 'https://www.facebook.com/', visible: false },
            { network: 'instagram', url: 'https://www.instagram.com/', visible: false },
        ],
    })
    const [ContactStyles, setContactStyles] = useState({
        card_type: '',
        reference_id: objectId,
        location: '',
        mobile_number: userProfile?.phone_no || '',
        call_visible: true,
        sms_visible: true,
        email: userProfile?.email || '',
        email_visible: true,
        whatsapp: userProfile?.phone_no || '',
        whatsapp_visible: true,
        address: '',
        state: '',
        postal_code: '',
        city: '',
        country: '',
        is_public: true,
    })

    const [AttachDocs, setAttachDocs] = useState({
        user_ref_id: "",
        card_id: null,
        card_name: "",
        images: [],
        videos: [],
        others: []
    });
    const visibleFiles = (files) => files.filter(file => file.visible); // Hide the attached files that are marked invisible
    const visibleImages = visibleFiles(AttachDocs.images).slice(0, maxImages);

    const [profilePicture, setProfilePicture] = useState('');

    useEffect(() => {
        if (cardDetails?.profile_pic) {
            const profilePic = cardDetails.profile_pic;
            setProfilePicture(profilePic);
        }
        else {
            setProfilePicture(DefaultProfileBg);
        }
    }, [cardDetails]);

    const initialCardDetails = {
        User_ID: `${id}`,
        CardType: `${card}`,
        CardName: '',
        profile_pic: '',
        logo: '',
        employee_id: '',
        company_id: '',
        is_professional_verified: false,
        is_student_verified: false,
        prefix: '',
        suffix: '',
        title: '',
        nickname: '',
        summary: '',
        designation: '',
        company: '',
        profession_department: '',
    };

    const initialCardStyles = {
        User_ID: `${id}`,
        CardType: `${card}`,
        font: '',
        size: '',
        style: '',
        colorPrimary: '',
        colorSecondary: '',
        colorTitle: '',
        colorLayout: '#0044C6',
        bgColor: '#ffffff',
        imageExtract: null,
        layoutStyle: card === 'Personal' ? '2' : '1',
    };

    const initialCardQrStyles = {
        User_ID: `${id}`,
        CardType: `${card}`,
        eyeBall: '',
        eyeBallcolor: '',
        eyeFrame: '',
        eyeFrameColor: '',
        qrPattern: '',
        qrPatterncolor: '#121212',
        border: '',
        bordercolor: '',
        addbg: '',
        addbgcolor: '#ede8e8'
    };

    const initialCardSocialLinks = {
        User_ID: `${id}`,
        card_type: `${card}`,
        links: [
            { network: 'linkedin', url: '', visible: false },
            // { network: 'whatsapp', url: '', visible: false },
            { network: 'facebook', url: '', visible: false },
            { network: 'instagram', url: '', visible: false },
        ],
    }

    const initialContactStyles = {
        card_type: `${id}`,
        CardType: `${card}`,
        CardName: `${card}`,
        location: '',
        mobile_number: `${userProfile.phone_no}`,
        call_visible: true,
        sms_visible: true,
        email: `${userProfile.email}`,
        email_visible: true,
        whatsapp: '',
        whatsapp_visible: true,
        address: '',
        state: '',
        postal_code: '',
        city: '',
        country: '',
        is_public: true,
    }

    useEffect(() => {

        handleCheckAccess();

        const fetchCardDetails = async () => {
            try {

                const userInfo = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
                    headers: headers
                });
                // console.log("userInfo :", userInfo);

                if (JSON.stringify(userProfile) !== JSON.stringify(userInfo.data?.data?.user)) {
                    setUserProfile(userInfo.data?.data?.user);
                }

                if (viewerToken) {

                    const viewerInfo = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/mail/user`, {
                        headers: viewerheaders
                    });

                    if (JSON.stringify(userProfile) !== JSON.stringify(userInfo.data?.data?.user)) {
                        setviewerProfile(viewerInfo.data?.data?.user);
                    }
                }



                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/getParticularCardInfo`, {
                    params: {
                        CardName: `${card}`,
                        referenceId: `${id}`
                    },
                    headers: headers
                });

                // console.log('Fetched card details:', response);
                // if (response.data.Details.length > 0) {
                //   setCardDetails(response.data.Details[0]);
                // }
                if (response.data.Details.length > 0) {
                    const details = response.data.Details[0];

                    // Create a new object with renamed keys and omit the old key
                    const { user_ref_id, ...restDetails } = details; // Destructure to remove user_ref_id
                    const renamedDetails = {
                        ...restDetails,
                        User_ID: user_ref_id, // Add User_ID with the value of user_ref_id
                    };

                    // Set the renamed object to state
                    setCardDetails(renamedDetails);
                }
                else {
                    setCardDetails(initialCardDetails);
                }
                if (response.data.QrStyles.length > 0) {

                    setCardQrStyles(response.data.QrStyles[0]);
                }
                else {
                    setCardQrStyles(initialCardQrStyles);
                }
                if (response.data.CardDesigns.length > 0) {
                    setCardStyles(response.data.CardDesigns[0]);
                }
                else {
                    setCardStyles(initialCardStyles);
                }

                const response2 = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/get-social-links`, {
                    params: {
                        cardType: `${card}`,
                    },
                    headers: headers,
                });
                // console.log('Fetched social links:', response.data);
                // setSocialLinks(response.data);
                const transformedLinks = response2.data.map((link) => ({
                    network: link.info_key,
                    url: link.info_value,
                    visible: link.is_visible,
                }));

                // console.log('Transformed Links: ', transformedLinks)

                setSocialLinks({
                    user_ref_id: `${id}`,
                    card_type: `${card}`,
                    links: transformedLinks,
                });
                // console.log("socip lonks",SocialLinks);

            }
            catch (error) {
                console.error("Error fetching card details:", error);
            }

            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/card/getcard-contacts`, {
                    params: {
                        card_type: `${card}`,
                    },
                    headers: headers,
                });
                if (response.status === 200) {
                    setContactStyles(response.data[0]);
                }
                else {
                    setContactStyles(initialContactStyles);
                }
            }
            catch (error) {
                console.log("It does not fetch the Card Contact Details");
                setContactStyles(initialContactStyles);
            }

            try {
                const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/v1/card/card_document/${card}`,
                    { headers: headers }
                );
                const { data } = response.data;

                if (data.length < 1) return;

                const restructuredData = {
                    user_ref_id: data.length ? data[0].user_ref_id : "",
                    card_id: data.length ? data[0].card_id : null,
                    card_name: id,
                    images: [],
                    videos: [],
                    others: []
                };

                data.forEach((doc) => {
                    const document = {
                        name: doc.document_name,
                        size: doc.size,
                        date: doc.date,
                        type: doc.document_type,
                        data: doc.public_url,
                        fileCat: doc.file_cat,
                        fileId: doc.file_id,
                        showQR: doc.showQR,
                        visible: doc.is_visible,
                    };

                    if (doc.file_cat === 'images') {
                        restructuredData.images.push(document);
                    } else if (doc.file_cat === 'videos') {
                        restructuredData.videos.push(document);
                    } else {
                        restructuredData.others.push(document);
                    }
                });

                // Update the state with the restructured data
                setAttachDocs(restructuredData);

            } catch (error) {
                console.error('Error fetching documents:', error);
                // Handle error accordingly, like showing an alert or a message to the user
            }

            // setLoading(false);

        }


        fetchCardDetails();
    }, [id, userProfile]);

    const firstName = userProfile?.first_name || "FirstName";
    const lastName = userProfile?.last_name || "LastName";
    const imageUrl = userProfile?.profile_url || DefaultProfile;
    const viewerfName = viewerProfile?.first_name || "viewerfName";
    const viewerlName = viewerProfile?.last_name || "viewerfName";
    const viewerUrl = viewerProfile?.profile_url || DefaultProfile;
    const userCompany = cardDetails?.company || "Company";
    const userDesignation = cardDetails?.designation || "Designation";
    const userTitle = cardDetails?.title || "Designation";
    const [phoneNo, setPhoneNo] = useState(userProfile?.phone_no || "");
    const [sms, setSms] = useState(userProfile?.email || "");
    const userEmail = useState(userProfile?.email || "");
    const userWhatsapp = ContactStyles.whatsapp?.input || phoneNo || '';



    const companyLogo = cardDetails?.logo === null ? (
        DefaultLogo
    ) : cardDetails?.logo;


    const getFontWeight = (style) => {
        switch (style) {
            case 'Light':
                return 300; // Font weight for Light
            case 'Regular':
                return 500; // Font weight for Regular
            case 'Medium':
                return 600; // Font weight for Medium
            case 'Semi Bold':
                return 700; // Font weight for Semi Bold
            case 'Bold':
                return 800; // Font weight for Bold
            default:
                return 'normal'; // Default font weight
        }
    };

    const [dialogueOpen, setDialogueOpen] = useState(false);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const canvasToImage = (canvas, type) => {
        return new Promise((resolve) => {
            canvas.toBlob((blob) => {
                resolve(blob);
            }, type);
        });
    };

    // Function to handle download button click
    const handleDownload = async () => {
        const canvas = document.querySelector('canvas');
        const blob = await canvasToImage(canvas, 'image/png'); // Change to 'image/jpeg' for JPEG format
        saveAs(blob, 'qrcode.png'); // Change file name and extension accordingly
    };

    const BootstrapDialog = styled(Dialog)(({ theme }) => ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
    }));

    const handleOpenDialogue = () => {
        setDialogueOpen(!dialogueOpen);
    };

    const handleCloseDialogue = () => {
        setDialogueOpen(false);
    };

    const handleClickOpen = () => {
        setPopoverOpen(!popoverOpen);
    };

    const handleClose = () => {
        setPopoverOpen(false);
    };

    const handleCreate = () => {
        window.location.href = "https://app.neoin.co/";  // Redirect to the desired location
    };

    const [IsOwnerVisitingCard, setIsOwnerVisitingCard] = useState(false);
    const handleCheckAccess = async () => {

        if (!storedobjectId || !CardStyles.CardType) {
            handleFailure('All fields are required');
            return;
        }


        else if (!viewerToken) {
            // toast.error('All fields are required');
            // return;
            setNonuser(true);
            setLoading(false)
        }
        try {
            const response = await axios.post('api/v1/consent/check-access', {
                ownerToken: storedobjectId,
                viewerToken,
                cardName: card,
            });


            //   console.log("consent response ",response);


            if (response.data.access) {
                handleSuccess('Access granted to the card.');
                setAccess(true)
                setLoading(false);
                setIsOwnerVisitingCard(response.data.owner);
            } else {
                console.log("access else ");
                // handleAskConsent();
                // toast.error(response.data.message || 'No access to the card.');
                setLoading(false);
            }
        } catch (error) {
            console.log("access catch ");
            setLoading(false)
            // handleAskConsent();
            // toast.error(error.response?.data?.message || 'An error occurred.');
        }
    };

    const handleAskConsent = async () => {
        setLoading(true);
        // setError('');

        try {
            const response = await axios.post('api/v1/consent/request-access', {
                ownerId: storedobjectId,
                cardName: card,
                requesterId: viewerToken
            });

            console.log("consent sent for request", response.status);
            if (response.status === 202) {
                handleSuccess('Your access request has been sent and is pending approval.')
            } else {
                // alert(response.data.message)
                handleSuccess('Sent consent request.');
            }
        } catch (err) {
            console.error("error in consent", err);
            // toast.error(err.response.data.message);
        } finally {
            setLoading(false);
        }
    };


    const handleView = async () => {
        setNonuser(false);
        setViewCard(true);
    };

    const onSkip = async () => {
        setNonuser(true);
        setViewCard(false);
        setVcf(false)
    }






    // const borderStyle = CardQrStyles.border === "border" ? { border: `4px solid ${CardQrStyles.bordercolor || '#000000'}` } : {};
    const [url1, setUrl] = useState(`${process.env.REACT_APP_CARD_URL}/digital-identity/${card}/${id}`);

    const message = url1;
    const encodedMessage = encodeURIComponent(message);
    const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodedMessage}`;
    // const telegramUsername = "YourTelegramUsername"; 
    const telegramLink = `https://t.me/${phoneNo}?text=${encodedMessage}`;
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${phoneNo}&quote=${encodedMessage}`;
    const anySocialIconsVisible = SocialLinks && SocialLinks.links?.some(link => link && link.visible);

    const getDisplayTitle = (title) => {
        switch (title) {
            case "Social Media":
                return "My Social Network";
            case "Business":
                return "My Businesses";
            case "Contact":
                return "My Contacts"
            case "Payment":
                return "My Payment Links"
            case "More":
                return "Others"
            case "Music":
                return "My Music"
            case "Portfolio":
                return "My Portfolio"
            case "Content":
                return "My Content"
            default:
                return title;
        }
    };

    const [Logo, setcompanyLogo] = useState('');
    useEffect(() => {

        if (cardDetails.logo && cardDetails.logo !== '') {
            // const companypic = `data:${cardDetails.CompanyLogo.type};base64,${cardDetails.CompanyLogo.data}`
            setcompanyLogo(cardDetails.logo);
            // console.log("logo in qr", companypic);
        }
        else {
            setcompanyLogo('')
        }
    }, [cardDetails]);

    useEffect(() => {
        if (ContactStyles.mobile_number) {
            setPhoneNo(ContactStyles.mobile_number);
        }
        else {
            setPhoneNo(userProfile.phone_no)
        }
        if (ContactStyles.email) {
            setSms(ContactStyles.email);
        }
        else {
            setSms(userProfile.email)
        }
    }, [ContactStyles, userProfile]);


    const [qrCodeOptions, setQrCodeOptions] = useState({
        dotsOptions: {
            color: "#000000",
            type: "square"
        },
        cornersSquareOptions: {
            color: "#000000",
            type: "square"
        },
        cornersDotOptions: {
            color: "#000000",
            type: "dot"
        },
        backgroundOptions: {
            color: "#ffff"
        }
    });

    const qrCodeRef = useRef(null);
    const qrCodeInstanceRef = useRef(null);
    // const [qrCodeSVG, setQrCodeSVG] = useState("");

    useEffect(() => {
        if (CardQrStyles) {
            setQrCodeOptions({
                dotsOptions: {
                    color: CardQrStyles.qrPatterncolor ?? "#000000",
                    type: CardQrStyles.qrPattern ?? "square"
                },
                cornersSquareOptions: {
                    color: CardQrStyles.eyeBallcolor ?? "#000000",
                    type: CardQrStyles.eyeBall ?? "dot"
                },
                cornersDotOptions: {
                    color: CardQrStyles.eyeFrameColor ?? "#000000",
                    type: CardQrStyles.eyeFrame ?? "dot"
                },
                backgroundOptions: {
                    color: CardQrStyles.addbgcolor ?? ""
                }
            });
        } else {
            console.log("Whether else condition works");
            setQrCodeOptions({
                dotsOptions: {
                    color: "#000000",
                    type: "square"
                },
                cornersSquareOptions: {
                    color: "#000000",
                    type: "dot"
                },
                cornersDotOptions: {
                    color: "#000000",
                    type: "dot"
                },
                backgroundOptions: {
                    color: ""
                }
            });
        }
    }, [CardQrStyles]);


    useEffect(() => {
        if (qrCodeRef.current) {
            if (Logo && !qrCodeInstanceRef.current) {
                console.log("Creating QR code with image", Logo);
                const qrCode = new QRCodeStyling({
                    width: 200,
                    height: 200,
                    data: url1,
                    ...qrCodeOptions,
                    image: Logo
                });
                qrCode.append(qrCodeRef.current);
                qrCodeInstanceRef.current = qrCode;
            } else if (!qrCodeInstanceRef.current) {
                console.log("Creating QR code without image");
                const qrCode = new QRCodeStyling({
                    width: 200,
                    height: 200,
                    data: url1,
                    ...qrCodeOptions
                });
                qrCode.append(qrCodeRef.current);
                qrCodeInstanceRef.current = qrCode;
            } else {
                console.log("Updating QR code123", Logo);
                qrCodeInstanceRef.current.update({ data: url1, ...qrCodeOptions });
                if (Logo && cardDetails.CardType != "Personal") {
                    qrCodeInstanceRef.current.update({ image: Logo });
                }
            }
        }
    }, [Logo, url1, qrCodeOptions, CardQrStyles]);

    const shouldShowContactSection = ContactStyles?.is_public && (
        ContactStyles?.address ||
        ContactStyles?.city ||
        ContactStyles?.state ||
        ContactStyles?.postal_code ||
        ContactStyles?.country
    );

    const layoutColor = CardStyles?.colorLayout || '#0044c6';

    const getLuminance = (hex) => {
        hex = hex.replace('#', '');
        const r = parseInt(hex.substring(0, 2), 16) / 255;
        const g = parseInt(hex.substring(2, 4), 16) / 255;
        const b = parseInt(hex.substring(4, 6), 16) / 255;

        const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
        return luminance;
    };

    const [labelColor, setLabelColor] = useState('#ffffff');
    useEffect(() => {
        const luminance = getLuminance(layoutColor);
        if (luminance > 0.5) {
            setLabelColor('#000000'); // Dark text for light background
        } else {
            setLabelColor('#ffffff'); // Light text for dark background
        }
    }, [layoutColor]);

    const layoutStyle = CardStyles.layoutStyle ? CardStyles.layoutStyle : (CardStyles.CardType === 'Personal' ? '2' : '1');
    const layoutProps = {
        profilePicture: profilePicture,
        cardType: cardDetails?.CardType?.startsWith("Customize_") ? cardDetails?.CardName || "CardName" : cardDetails?.CardName,
        companyLogo,
        prefix: cardDetails?.prefix,
        suffix: cardDetails?.suffix,
        firstName,
        lastName,
        companyName: cardDetails?.company || "",
        designation: cardDetails?.designation || "",
        title: cardDetails?.title,
        colorPrimary: CardStyles.colorPrimary,
        colorSecondary: CardStyles.colorSecondary,
        colorTitle: CardStyles.colorTitle,
        bgColor: CardStyles?.bgColor || "#ffff",
        layoutColor,
        labelColor,
        handleOpenDialog: handleOpenDialogue,
        handleShareClick: handleClickOpen,
        phoneNo: ContactStyles?.mobile_number || userProfile.phone_no,
        emailId: ContactStyles?.email || userProfile.email,
        isVerified: cardDetails?.is_professional_verified,
        userDetails: userProfile,
        isOwner: IsOwnerVisitingCard
    };


    const addressData = {
        city: "Banglore",
        state: "Karnataka",
        postal_code: "582101",
        country: "India",
    };

    const fullAddress = (ContactStyles?.address || ContactStyles?.city)
        ? `${ContactStyles?.address}, ${ContactStyles?.city}, ${ContactStyles?.state} ${ContactStyles?.postal_code}, ${ContactStyles?.country}`
        : `${addressData.city}, ${addressData.state}, ${addressData.postal_code}, ${addressData.country}`;

    useEffect(() => {
        const timer = setTimeout(() => {
            setLoading(false);
        }, 2000);

        return () => clearTimeout(timer); // Clean up the timer on component unmount
    }, []);

    if (loading) {
        return <UserDetails2Skeleton />;
    } else if (isNonuser) {
        return (
            <>
                {/* <div style={{ background: "#172C5780", minHeight: "100vh" }}> */}
                <div className="" style={{ height: "100vh", flexDirection: "column" }}>
                    <div className="col-md-12 d-flex justify-content-center">
                        <div style={{
                            fontStyle: CardStyles?.style,
                            fontFamily: CardStyles?.font,
                            fontWeight: getFontWeight(CardStyles?.style),
                            fontSize: CardStyles?.size,
                            color: CardStyles?.colorSecondary,
                            maxWidth: '366px',  // Add a maximum width
                            width: '100%'       // Ensure it takes full width within max-width
                        }}>
                            <Box className="preview-card my-4 user-details-box-1" sx={{
                                border: "2px solid #0000001F",
                                borderRadius: 2,
                                backgroundColor: CardStyles.bgColor
                            }}>
                                <div id='Card-firstPart-createNew'>
                                    {renderLayout(layoutStyle, layoutProps)}

                                    {CardStyles?.layoutStyle === '2' ? (<></>) :
                                        <div className={`${CardStyles.layoutStyle === '4' ? 'line-card layout-4-extra-margin' : 'mt-2 line-card'}`}>
                                            <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                                            <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                                                <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor }}>
                                                    {cardDetails?.is_professional_verified === true ? <VerifiedTickN title="Verified" /> : <NonVerifiedTickNew title="Not Verified" />}
                                                </div>
                                            </div>
                                        </div>
                                    }

                                    <div className="d-flex justify-content-evenly align-items-center mb-3">
                                        <div className="me-2">
                                            <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleView}>VIEW CARD</Button>
                                        </div>
                                        <div className="ms-2">
                                            <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleCreate}>CREATE ACCOUNT</Button>
                                        </div>
                                    </div>



                                </div>
                            </Box>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    else if (isAccessible) {
        let age = calculateAge(userProfile?.dob);

        const shouldShowProfessionalInfo = (
            cardDetails?.profession_department ||
            cardDetails?.employee_id ||
            cardDetails?.company_id ||
            cardDetails?.professional_email_id ||
            cardDetails?.company
        );

        const shouldShowEducationInfo = (
            cardDetails?.education_level ||
            cardDetails?.institute ||
            cardDetails?.board ||
            cardDetails?.degree ||
            cardDetails?.field_of_study ||
            cardDetails?.grade

        );

        const shouldShowProfessionalSection = (
            cardDetails?.CardType === "Professional" ||
            cardDetails?.CardType === "GenZ" ||
            cardDetails?.CardType === "Customize_GenZ" ||
            cardDetails?.CardType === "Customize_Professional"
        ) && shouldShowProfessionalInfo;

        const shouldShowEducationSection = (
            cardDetails?.CardType === "Student" ||

            cardDetails?.CardType === "Customize_Student"
        ) && shouldShowEducationInfo;

        const cardVariants = {
            hidden: { opacity: 0, x: -100 },
            visible: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: 100 },
        };


        const bottomToTopVariants = {
            hidden: { opacity: 0, y: 100 },
            visible: { opacity: 1, y: 0 },
            exit: { opacity: 0, y: -100 },
        };

        const rightToLeftVariants = {
            hidden: { opacity: 0, x: 100 },
            visible: { opacity: 1, x: 0 },
            exit: { opacity: 0, x: -100 },
        };

        return (
            <>
                {userProfile !== null && isAccessible && (
                    <>
                        <div className="row gx-0" >
                            <div className="col-md-12 col-lg-3"  >
                                <div style={{ fontStyle: CardStyles?.style, fontFamily: CardStyles?.font, fontWeight: getFontWeight(CardStyles?.style), fontSize: CardStyles?.size, color: CardStyles?.colorSecondary }}>
                                    <Box className="preview-card my-4 ms-4 user-details-box-1" sx={{ border: "2px solid #0000001F", borderRadius: 2, backgroundColor: CardStyles.bgColor }}>
                                        <div id='Card-firstPart-createNew' >
                                            <motion.div
                                                initial="hidden"
                                                animate="visible"
                                                exit="exit"
                                                variants={cardVariants}
                                                transition={{ duration: 0.5 }}
                                            >
                                                {renderLayout(layoutStyle, layoutProps)}

                                                <div className={`${CardStyles.layoutStyle === '4' ? 'line-card layout-4-extra-margin' : 'mt-2 line-card'}`} >
                                                    <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                                                    <div className="icon icon-alignment-card d-flex align-items-center justify-content-center" >
                                                        {!IsOwnerVisitingCard &&
                                                            <Vcfcard userProfile={userProfile} cardDetails={cardDetails} ContactStyles={ContactStyles} layoutColor={layoutColor} />
                                                        }
                                                        <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor, }}>
                                                            {cardDetails?.is_professional_verified === true ? <VerifiedTickN title="Verified" /> : <NonVerifiedTickNew title="Not Verified" />}
                                                        </div>
                                                        {!IsOwnerVisitingCard &&
                                                            <div className='icon-border flex-center' style={{ borderColor: layoutColor, }}>
                                                                <IoMdShare className='icon-color' onClick={handleClickOpen} />
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className='summary-container'>
                                                    {cardDetails?.summary}
                                                </div>

                                                {age &&
                                                    <div className='mt-4 mx-3'>
                                                        <h5 className='d-flex justify-content-start text-left fw-bold' style={{ color: CardStyles?.colorTitle || '' }}>Personal Details</h5>
                                                        <div className='box-paragraph' style={{ borderColor: layoutColor }}>
                                                            <div className='d-flex justify-content-start'>
                                                                <EventIcon />
                                                                <div className='ms-1'>Age: </div>
                                                                <div className='mx-2'> {age} Years Old</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                }

                                                {shouldShowProfessionalSection && (
                                                    <div className='mt-4 mx-3'>
                                                        <h5 className='d-flex justify-content-start text-left fw-bold' style={{ color: CardStyles?.colorTitle || '' }}>
                                                            Professional Information
                                                        </h5>
                                                        <div className='box-paragraph text-start' style={{ fontSize: "16px", lineHeight: "24px", borderColor: layoutColor }}>
                                                            {[
                                                                { label: 'Department', value: cardDetails?.profession_department },
                                                                { label: 'Company', value: cardDetails?.company },
                                                                { label: 'Employee ID', value: cardDetails?.employee_id },
                                                                { label: 'Company ID', value: cardDetails?.company_id },
                                                                { label: 'Email ID', value: cardDetails?.professional_email_id },

                                                            ]
                                                                .filter((field) => field.value) // Filter out fields with no value
                                                                .map((field, index) => (
                                                                    <div key={index} className={`d-flex justify-content-start flex-wrap`}>
                                                                        <div className='ms-1'>{field.label}:</div>
                                                                        <div className='mx-1 fw-semibold'>{field.value}</div>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                )}


                                                {shouldShowEducationInfo && (
                                                    <div className='mt-4 mx-3'>
                                                        <h5 className='d-flex justify-content-start text-left fw-bold' style={{ color: CardStyles?.colorTitle || '' }}>
                                                            Student Information
                                                        </h5>
                                                        <div className='box-paragraph text-start' style={{ fontSize: "16px", lineHeight: "24px", borderColor: layoutColor }}>
                                                            {[
                                                                { label: 'Education Level', value: cardDetails?.education_level },
                                                                { label: 'Institute', value: cardDetails?.institute },
                                                                { label: 'Board', value: cardDetails?.board },
                                                                { label: 'Degree', value: cardDetails?.degree },
                                                                { label: 'Field of study', value: cardDetails?.field_of_study },
                                                                { label: 'Grade', value: cardDetails?.grade },
                                                                // { label: 'Student Email', value: cardDetails?.student_email_id },

                                                            ]
                                                                .filter((field) => field.value) // Filter out fields with no value
                                                                .map((field, index) => (
                                                                    <div key={index} className={`d-flex justify-content-start flex-wrap`}>
                                                                        <div className='ms-1'>{field.label}:</div>
                                                                        <div className='mx-1 fw-semibold'>{field.value}</div>
                                                                    </div>
                                                                ))}
                                                        </div>
                                                    </div>
                                                )}



                                                <div className="text-center mb-3">
                                                    {/* {isViewCard ? (<></>
                                                ) : (<>
                                                    <Vcfcard userProfile={userProfile} cardDetails={cardDetails} ContactStyles={ContactStyles} />
                                                </>
                                                )} */}
                                                </div>

                                                <div className="dialogue-overlay" style={{ display: dialogueOpen ? 'block' : 'none', }} onClick={handleCloseDialogue}>
                                                    <div className='Scanner-outline-preview' >
                                                        <div className='Displaying-QR'>
                                                            <span className='d-block text-center'>Scan me</span>
                                                            <div className={"qrCodeContainer"}>
                                                                <div ref={qrCodeRef}></div>
                                                                {/* <QrCodeCard /> */}
                                                            </div>
                                                            <span className='d-block text-center'>scan or click to preview</span>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ShareCardToContacts open={popoverOpen} onClose={handleClose} cardOwnerDetails={userProfile} viewerProfile={viewerProfile} />
                                            </motion.div>
                                        </div>
                                    </Box>
                                </div>
                            </div>
                            <div className="col-md-12 col-lg-6">
                                <motion.div
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={bottomToTopVariants}
                                    transition={{ duration: 0.5 }}>
                                    <Box className="preview-card m-4 p-4 user-details-box-2" sx={{ border: "2px solid #0000001F", borderRadius: 2 }} >
                                        <div className='d-flex align-items-center justify-content-between mt-4 quick-link-container user-details-2'>
                                            {ContactStyles?.call_visible && <div className='flex-center flex-column quick-link-icon'>
                                                <a href={`tel:${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                                    <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><MdOutlinePhoneIphone className='icon-color3' /></div>
                                                    <div className='text-center'>Call</div>
                                                </a>
                                            </div>}
                                            {ContactStyles?.sms_visible && <div className='flex-center flex-column quick-link-icon'>
                                                <a href={`sms:${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                                    <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><SmsIcon className='icon-color3' /></div>
                                                    <div className='text-center'>SMS</div>
                                                </a>
                                            </div>}
                                            {ContactStyles?.email_visible && <div className='flex-center flex-column quick-link-icon'>
                                                <a href={`mailto:${sms}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                                    <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><EmailIcon className='icon-color3' /></div>
                                                    <div className='text-center'>Email</div>
                                                </a>
                                            </div>}
                                            {ContactStyles?.whatsapp_visible && <div className='flex-center flex-column quick-link-icon'>
                                                <a href={`https://wa.me/${phoneNo}`} target='_blank' rel='noreferrer' className='flex-center flex-column' >
                                                    <div className='icon icon-outside flex-center m-0' style={{ backgroundColor: CardStyles?.bgColor ? CardStyles.colorLayout : "#0044C6" }}><WhatsappFilled className='icon-color3' /></div>
                                                    <div className='text-center'>WhatsApp</div>
                                                </a>
                                            </div>}
                                        </div>

                                        {/* <div className='mt-4'>
                                        <h5 style={{ color: CardStyles.colorTitle }}> My Social Network </h5>
                                        <div className="row user-details-social-icons professional-socialicons-container ">
                                           
                                                <div className="col-3 col-lg-2">
                                                    <div className="square-box"><LinkedinIcon style={{height: "40px", width: "40px"}}/></div>
                                                </div>
                                                <div className="col-3 col-lg-2">
                                                    <div className="square-box"><FacebookIcon style={{height: "40px", width: "40px"}}/></div>
                                                
                                                </div>
                                                <div className="col-3 col-lg-2">
                                                <a href={whatsappLink} target='_blank' rel='noreferrer'>
                                                    <div className="square-box"><WhatsappIcon style={{height: "40px", width: "40px"}}/></div>
                                                </a>
                                                </div>
                                                <div className="col-3 col-lg-2">
                                                    <div className="square-box"><InstagramIcon style={{height: "40px", width: "40px"}}/></div>
                                                </div>
                                        </div>
                                    </div> */}

                                        {anySocialIconsVisible && (
                                            <div className='mb-4 mx-3 social-icons-wrapper'>
                                                {socialLinksSections.map(section => (
                                                    (section.title !== "Recommended") && ( // Exclude Recommended section
                                                        <div className='my-4' key={section.title}>
                                                            {SocialLinks.links.some(link => link.visible && section.links.some(secLink => secLink.network === link.network)) && ( // Check if any visible icons under this section
                                                                <React.Fragment>
                                                                    <h5 className='mb-2' style={{ color: CardStyles?.colorTitle || '' }}>{getDisplayTitle(section.title)}</h5>
                                                                    <div className="social-icons-rows">
                                                                        {SocialLinks.links.map((link) => (
                                                                            link.visible && section.links.some(secLink => secLink.network === link.network) && (
                                                                                <a key={link.network} href={link.url} target='_blank' rel='nonreferrer'>
                                                                                    <div className="square-box">
                                                                                        {/* Get the icon using getIconAndLabel */}
                                                                                        {(() => {
                                                                                            const { icon: Icon } = getIconAndLabel(link.network);
                                                                                            return Icon ? <Icon className="social-icon svg-icon-32px" /> : null;
                                                                                        })()}
                                                                                    </div>
                                                                                </a>
                                                                            )
                                                                        ))}
                                                                    </div>
                                                                </React.Fragment>
                                                            )}
                                                        </div>
                                                    )
                                                ))}
                                            </div>
                                        )}

                                    </Box>
                                </motion.div>
                            </div>
                            <div className="col-md-12 col-lg-3">
                                <motion.div
                                    initial="hidden"
                                    animate="visible"
                                    exit="exit"
                                    variants={rightToLeftVariants}
                                    transition={{ duration: 0.5 }}
                                >
                                    <Box className="preview-card my-4 me-4 p-4 user-details-box-3" sx={{ border: "2px solid #0000001F", borderRadius: 2 }}>

                                        {/* <div className='mt-4 mx-3'> */}
                                        {/* <h5 style={{ color: CardStyles ? CardStyles.colorTitle : "#000000" }}> Files </h5> */}
                                        {AttachDocs.images.length === 0 && AttachDocs.videos.length === 0 && AttachDocs.others.length === 0 ? (<></>
                                            // <p>No files uploaded yet. {console.log("inside ? ...")} </p>
                                        ) : (
                                            <div>
                                                {visibleImages.length > 0 && (
                                                    <div>
                                                        <div className="professional-social-title mb-2">Images</div>
                                                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px', maxHeight: '220px', justifyContent: "center" }}>
                                                            {visibleImages.map((file, index) => (
                                                                <div key={index} style={{ width: '99px', height: '100px', boxSizing: 'border-box' }}>
                                                                    <img src={file.data} alt={file.name} style={{ width: '100%', height: '100%', objectFit: 'contain', borderRadius: '12px' }} />
                                                                </div>
                                                            ))}
                                                            {AttachDocs.images.length > maxImages && (
                                                                <div
                                                                    style={{ width: '99px', height: '100px', boxSizing: 'border-box', display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#e0e0e0', borderRadius: '8px' }}
                                                                    onClick={handleViewMoreClick}
                                                                >
                                                                    <span>{AttachDocs.images.length - maxImages}+ View More</span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )}
                                                {visibleFiles(AttachDocs.videos).length > 0 && (
                                                    <div className='my-2'>
                                                        <div className="professional-social-title">Video</div>
                                                        {visibleFiles(AttachDocs.videos).map((file, index) => (
                                                            <div key={index}>
                                                                <ReactPlayer url={file.data} loop controls className='mx-auto preview-media-display' />
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                                {visibleFiles(AttachDocs.others).length > 0 && (
                                                    <div className='my-2'>
                                                        <div className="professional-social-title">Files</div>
                                                        {visibleFiles(AttachDocs.others).map((file, index) => (
                                                            <div key={index} className="my-2">
                                                                {/* <a href={`data:${file.type};base64,${file.data}`} target='_blank' rel='noreferrer'> */}
                                                                <PreviewFileItem file={file} fontColor="blue-magenta" />
                                                                {/* </a> */}
                                                            </div>
                                                        ))}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        {/* </div>s */}


                                        <Modal open={isModalOpen} onClose={handleCloseModal}>
                                            <Box sx={{ maxWidth: '80%', margin: 'auto', padding: '20px', backgroundColor: 'white', borderRadius: '8px', overflowY: 'auto' }}>
                                                <h2>All Images</h2>
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                                    {visibleFiles(AttachDocs.images).map((file, index) => (
                                                        <div key={index} style={{ flex: '1 1 calc(25% - 10px)', boxSizing: 'border-box' }}>
                                                            <img src={file.data} alt={file.name} style={{ width: '100%', height: '150px', objectFit: 'cover', borderRadius: '8px' }} />
                                                        </div>
                                                    ))}
                                                </div>
                                            </Box>
                                        </Modal>
                                        <div className='mt-3'>
                                            <div className="professional-social-title">Location</div>
                                            <div className="professional-map-containerNew mt-3 flex-center width-auto" style={{ width: "auto", height: "300px", overflow: "hidden" }}>


                                                {/* <MapIntegration style={{ borderRadius: "6px" }} latitude="12.9798710248994" longitude="77.60654611960474" /> */}

                                                < MapWithAddress address={fullAddress} style={{ borderRadius: "4px" }} />
                                            </div>
                                        </div>

                                        {shouldShowContactSection && (
                                            <div className='mt-4 mx-3'>
                                                <div className="professional-social-title">Contact</div>
                                                <div className='box-paragraph' style={{ fontSize: "16px", lineHeight: "24px" }}>
                                                    {ContactStyles?.address && (
                                                        <div className='d-flex justify-content-start'>
                                                            <div className='ms-1'>Address:</div>
                                                            <div className='mx-2'>{ContactStyles.address}</div>
                                                        </div>
                                                    )}

                                                    {ContactStyles?.city && (
                                                        <div className='d-flex justify-content-start'>
                                                            <div className='ms-1'>City:</div>
                                                            <div className='mx-2'>{ContactStyles.city}</div>
                                                        </div>
                                                    )}

                                                    {ContactStyles?.state && (
                                                        <div className='d-flex justify-content-start'>
                                                            <div className='ms-1'>State:</div>
                                                            <div className='mx-2'>{ContactStyles.state}</div>
                                                        </div>
                                                    )}

                                                    {ContactStyles?.country && (
                                                        <div className='d-flex justify-content-start'>
                                                            <div className='ms-1'>Country:</div>
                                                            <div className='mx-2'>{ContactStyles.country}</div>
                                                        </div>
                                                    )}

                                                    {ContactStyles?.postal_code && (
                                                        <div className='d-flex justify-content-start'>
                                                            <div className='ms-1'>Postal:</div>
                                                            <div className='mx-2'>{ContactStyles.postal_code}</div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        )}
                                    </Box>
                                </motion.div>
                            </div>
                        </div>
                    </>
                )
                }
            </>
        )
    }

    else if (isviewcard) {
        return (
            <>
                <Dialog open={true} onClose={onSkip} maxWidth="sm" fullWidth>
                    <DialogTitle className='pb-1'>
                        Connect with {firstName} {lastName}
                        <IconButton onClick={onSkip} aria-label="close" style={{ position: 'absolute', right: 8, top: 8 }}>
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>
                    <DialogContent>
                        <p className='mt-0 mb-4'>To view {firstName}’s card, please provide your details below.</p>

                        <form className='d-flex flex-column gap-3'>
                            {/* Full Name */}
                            <TextField
                                className='m-0'
                                label="First Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="firstName"
                                value={nonUserData.firstName}
                                onChange={handleInputChange}
                                error={errors.firstName}
                                helperText={errors.firstName ? 'First name is required.' : ''}
                            />

                            <TextField
                                className='m-0'
                                label="Last Name"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="lastName"
                                value={nonUserData.lastName}
                                onChange={handleInputChange}
                                error={errors.lastName}
                                helperText={errors.lastName ? 'Last name is required.' : ''}
                                required
                            />

                            {/* Phone Number */}
                            <MuiTelInput
                                className='m-0'
                                name="phoneNumber"
                                value={nonUserData.phoneNumber}
                                onChange={(value) => handlePhoneChange(value, 'phoneNumber')}
                                onCountryChange={handleCountryChange}
                                defaultCountry="IN" // Set default country here
                                required
                                fullWidth
                                error={errors.phoneNumber}
                                helperText={errors.phoneNumber ? 'Enter Valid Phone number.' : ''}
                                margin="normal" // Apply margin here for spacing
                            />

                            {/* Email Address */}
                            <TextField
                                className='m-0'
                                label="Email"
                                variant="outlined"
                                fullWidth
                                margin="normal"
                                name="email"
                                value={nonUserData.email}
                                onChange={handleInputChange}
                                error={errors.email}
                                helperText={errors.email ? 'Enter Valid Email ID' : ''}
                            />

                            {/* Buttons */}
                            <div className="d-flex justify-content-end mt-2">
                                {!isvcf && (
                                    <>
                                        <Button onClick={onSkip} sx={{ mr: 2, color: "#0044c6" }}>
                                            Skip
                                        </Button>
                                        <Button
                                            variant="contained"
                                            disabled={isSaveDisabled}
                                            sx={{ backgroundColor: "#0044C6" }}
                                            onClick={handleSubmit}
                                        >
                                            Connect
                                        </Button>
                                    </>
                                )}
                            </div>

                            {isvcf && (
                                <div className="mt-2">
                                    <AutoVcfcard userProfile={userProfile} cardDetails={cardDetails} ContactStyles={ContactStyles} isDownloaded={false} />
                                </div>
                            )}
                        </form>

                    </DialogContent>
                </Dialog>
            </>
        );
    }


    else if (!isAccessible) {

        return (
            <>
                <div style={{ background: "#172C5780", minHeight: "100vh" }}>
                    <div className="" style={{ height: "100vh", flexDirection: "column" }}>
                        <div className="col-md-12 d-flex justify-content-center">
                            <div style={{
                                fontStyle: CardStyles?.style,
                                fontFamily: CardStyles?.font,
                                fontWeight: getFontWeight(CardStyles?.style),
                                fontSize: CardStyles?.size,
                                color: CardStyles?.colorSecondary,
                                maxWidth: '366px',  // Add a maximum width
                                width: '100%'       // Ensure it takes full width within max-width
                            }}>
                                <Box className="preview-card my-4 user-details-box-1" sx={{
                                    border: "2px solid #0000001F",
                                    borderRadius: 2,
                                    backgroundColor: CardStyles.bgColor
                                }}>
                                    <div id='Card-firstPart-createNew'>
                                        {renderLayout(layoutStyle, layoutProps)}

                                        {CardStyles?.layoutStyle === '2' ? (<></>) :
                                            <div className={`${CardStyles.layoutStyle === '4' ? 'line-card layout-4-extra-margin' : 'mt-2 line-card'}`}>
                                                <div className="line-blue" style={{ backgroundColor: layoutColor }}></div>
                                                <div className="icon icon-alignment-card d-flex align-items-center justify-content-center">
                                                    <div className='icon-border icon-verify-symbol me-3 flex-center' style={{ borderColor: layoutColor }}>
                                                        {cardDetails?.is_professional_verified === true ? <VerifiedTickN title="Verified" /> : <NonVerifiedTickNew title="Not Verified" />}
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        <div className="d-flex justify-content-evenly align-items-center mb-3">
                                            <div className="me-2">
                                                <Button variant="contained" sx={{ backgroundColor: "#0044C6" }} onClick={handleAskConsent}>
                                                    Ask For Consent
                                                </Button>
                                            </div>
                                            {/* <div className="ms-2">
                                                {isViewCard ? null : (
                                                    <ConsentVcf userProfile={userProfile} cardDetails={cardDetails} ContactStyles={ContactStyles} />
                                                )}
                                            </div> */}
                                        </div>

                                    </div>
                                </Box>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

const ShareCardToContacts = ({ open, onClose, cardOwnerDetails, viewerProfile }) => {
    const viewerToken = localStorage.getItem('objectId')?.trim();
    const apiKey = process.env.REACT_APP_API_KEY;
    const viewerheaders = {
        'x-api-key': apiKey,
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${viewerToken}`
    };
    axios.defaults.baseURL = `${process.env.REACT_APP_BACKEND_URL}`;
    const { card } = useParams();

    const [selectedContacts, setSelectedContacts] = useState([]); // Array for multiple selected contacts
    const [ConnectedContacts, setConnectedContacts] = useState([]);
    const [filteredContacts, setFilteredContacts] = useState(ConnectedContacts);
    const [searchQuery, setSearchQuery] = useState('');
    const cardUrl = window.location.href;
    const { handleSuccess, handleFailure } = useQuantityContext();

    useEffect(() => {
        const fetchContacts = async () => {
            try {
                if (viewerToken) {
                    const response = await axios.get(`/usercontact/connections`, { headers: viewerheaders });
                    const data = response.data;
                    if (data.statusCode === 200) {
                        const members = data.data.filter(member => member.contact_ref_id != cardOwnerDetails.reference_id) // Exclude matching contact_ref_id
                            .map(member => {
                                return {
                                    id: member.id,
                                    contact_ref_id: member.contact_ref_id,
                                    img: member.profile_url,
                                    is_favourite: member?.is_favourite ? true : false,
                                    first_name: member.first_name,
                                    last_name: member.last_name,
                                    name: `${member.first_name} ${member.last_name}`,
                                    verified: member.is_verified ? true : false,
                                    neoin_id: member.unique_id,
                                    email: member.email
                                };
                            });
                        setConnectedContacts(members);
                        setFilteredContacts(members);
                    }
                }
            } catch (error) {
                console.error("Error fetching card details:", error);
            }
        };
        fetchContacts();
    }, [viewerToken]);

    const handleInputChange = (event) => {
        setSearchQuery(event.target.value);
    };

    const filterContacts = (query) => {
        const lowerCaseQuery = query.toLowerCase();
        const results = ConnectedContacts.filter(member => {
            const fullName = `${member.name}`.toLowerCase();
            const matchesQuery = fullName.includes(lowerCaseQuery) || member.neoin_id.toLowerCase().includes(lowerCaseQuery);
            return matchesQuery;
        });

        const uniqueResults = Array.from(new Set(results.map(member => member.contact_ref_id)))
            .map(id => results.find(member => member.contact_ref_id === id));
        setFilteredContacts(uniqueResults.slice(0, 20));
    };

    useEffect(() => {
        const debounceSearch = setTimeout(() => {
            filterContacts(searchQuery);
        }, 300);
        return () => clearTimeout(debounceSearch);
    }, [searchQuery]);

    const handleCheckboxChange = (contact) => {
        setSelectedContacts((prevSelected) => {
            const isSelected = prevSelected.some(item => item.neoin_id === contact.neoin_id);

            if (isSelected) {
                // If the contact is already selected, remove it
                return prevSelected.filter(item => item.neoin_id !== contact.neoin_id);
            } else {
                // Only include the necessary fields when adding a contact
                const selectedContact = {
                    firstName: contact.first_name,
                    lastName: contact.last_name,
                    neoin_id: contact.neoin_id,
                    contact_ref_id: contact.contact_ref_id,
                    email: contact.email
                };
                return [...prevSelected, selectedContact];
            }
        });
    };

    const handleShareCard = async () => {
        const apipayload = {
            cardName: card,
            url: cardUrl,
            cardOwnerDetails: {
                firstName: cardOwnerDetails?.first_name,
                lastName: cardOwnerDetails?.last_name,
                neoin_id: cardOwnerDetails?.unique_id,
                contact_ref_id: cardOwnerDetails.reference_id,
                email: cardOwnerDetails.email
            },
            viewerDetails: {
                firstName: viewerProfile?.first_name,
                lastName: viewerProfile?.last_name,
                neoin_id: viewerProfile?.unique_id,
                contact_ref_id: viewerProfile?.reference_id
            },
            toShareMembersDetails: selectedContacts,
        }
        try {
            const response = await axios.post(`/mail/share-card-qrlink`, apipayload,
                {
                    headers: viewerheaders,
                }
            );
            const data = response.data;
            if (data.success) {
                handleSuccess("Shared Successfully");
            }
            else {
                handleFailure("Something Wrong. Try again Later");
            }
        }
        catch (error) {
            handleFailure("Something Wrong. Try again Later");
        }
        finally {
            setSelectedContacts([]);
            onClose();
        }
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <Box style={{ minWidth: "550px" }}>
                <div className='flex-center-between px-4 pt-4'>
                    <div>Share Card to your Contact List</div>
                    <IconButton className="m-0 p-0" onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className='d-flex align-items-center justify-content-between px-4 my-3'>
                    <TextField
                        style={{ width: "70%" }}
                        placeholder="Search by ID or name"
                        variant="outlined"
                        size="small"
                        className="me-2"
                        value={searchQuery}
                        onChange={handleInputChange}
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon className="icon-color" />
                                </InputAdornment>
                            ),
                        }}
                    />
                </div>

                <DialogContent className='m-0 p-0' style={{ scrollbarWidth: "thin", maxHeight: "350px", overflowY: "auto" }}>
                    {filteredContacts.length > 0 ? (
                        filteredContacts.map((member) => (
                            <div key={member.neoin_id} className='p-3 group_card_adding_memb w-100'>
                                <div className='person_details flex-center-between'>
                                    <div className='profile_name_details d-flex align-items-center gap-2'>
                                        <div style={{ width: "40px", height: "40px", position: "relative" }}>
                                            <Avatar src={member.img} alt={member.name}>{member.name.charAt(0)}</Avatar>
                                            <div className={`flex-center icon-16px`} style={{ position: "absolute", right: 0, bottom: 0, backgroundColor: "#fff", borderRadius: "50%" }}>
                                                {member.verified ? <VerifiedTickN style={{ color: "#43A047" }} /> : <NonVerifiedTickNew />}
                                            </div>
                                        </div>
                                        <div className='d-flex flex-column'>
                                            <div>{member.name}</div>
                                            <div>{member.neoin_id}</div>
                                        </div>
                                    </div>
                                    <Checkbox
                                        checked={selectedContacts.some(item => item.neoin_id === member.neoin_id)}
                                        onChange={() => handleCheckboxChange(member)}
                                    />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className="p-3 text-center">
                            No Connected Contacts
                        </div>
                    )}
                </DialogContent>

                {filteredContacts.length > 0 &&
                    <div style={{ borderTop: "1px solid rgba(0, 0, 0, 0.18)" }}></div>
                }
                <div className='d-flex align-items-center justify-content-end gap-3 my-4 mx-4'>
                    <Button onClick={onClose} className='color-blue'>Cancel</Button>
                    <Button variant='contained' sx={{ backgroundColor: "#0044C6" }} onClick={handleShareCard} disabled={selectedContacts.length === 0}>Share</Button>
                </div>
            </Box>
        </Dialog>
    );
};


export default UserDetails2;